module.exports = __webpack_public_path__ + "static/media/dashboard.a3d678f4.svg";